import { Box } from "@mui/material";
import React from "react";
import GameItem from "./GameItem";

const GameGrid = ({ games }) => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "repeat(auto-fill, minmax(200px, 1fr))" },
        gap: 2,
        p: 2,
      }}
    >
      {games.map((game) => (
        <GameItem key={game.id} game={game} />
      ))}
    </Box>
  );
};

export default GameGrid;
